module.exports = __webpack_public_path__ + "img/xingzb.3458f5fa.svg";